<div *ngIf='(viewState$ | async) as v'>
  <div *ngIf='v.isLoading'>
    <div class="mt-5 text-center h1-responsive">
      <p>Loading {{v.confirmNumber}}...</p>
    </div>
    <div class="mt-5 text-center">
      <mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner>
    </div>
  </div>
  <div *ngIf='v.isError'>
    <div class="mt-5 text-center h1-responsive">
      <p class="text-danger">'{{v.confirmNumber}}' - {{v.errorMessage}}</p>
    </div>
  </div>
  <div *ngIf='v.isLoaded'>

    <div *ngIf='v.isFound'>
      <div class="mt-5 text-center h1-responsive">
        <p class="text-danger">'{{v.confirmNumber}}' - not found.</p>
      </div>
    </div>

    <div *ngIf='!v.isFound'>

      <!-- first row -->
      <div class="row mb-5  mt-lg-2">
        <!--First column-->
        <div class="col-lg-4 panel-title mb-5 mt-3 text-center">
          <h1><span class="px-4 py-3 white-text z-depth-1-half blue-gradient"
              style="border-radius: 5px;">Reservation</span></h1>
        </div>
        <!--/First column-->

        <!--Second column-->
        <div class="col-lg-8">

          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-2">
                  <p class="h4-responsive text-center">
                    <span>{{v.confirmNumber}}</span><br />
                    <span *ngIf="v.dataAtlas" class="badge p-2 ml-2 primary-badge">{{v.dataAtlas.tripNumber}} /
                      {{v.dataAtlas.department}}</span>
                  </p>
                </div>
                <div class="col-md-2">
                  <p class="h4-responsive text-center">
                    {{v.data['@type']}}
                  </p>
                </div>

                <div class="col-md-4">
                  <p class="h4-responsive text-center">
                    <span>{{v.data['@pickupDate']}} {{v.data['@pickupTime']}}</span><br />
                    <span *ngIf="v.dataAtlas" class="badge p-2 ml-2 primary-badge">{{v.dataAtlas.tripDate}}
                      {{v.dataAtlas.tripTime}}</span>
                  </p>
                </div>
                <div class="col-md-4">
                  <p class="h4-responsive text-center">
                    <span>${{v.data.pricing['@total']}} ({{v.data.pricing['@rateType']}})</span><br />
                    <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                      [ngClass]="{'success-badge': v.matches.total && v.matches.rateType, 'danger-badge': !v.matches.total || !v.matches.rateType }">
                      ${{v.dataAtlas.total}} ({{v.dataAtlas.isRatedHourly == 'true' ? 'hourly' : 'flat'}})
                    </span>
                  </p>
                  <p class="h4-responsive text-center"
                    *ngIf="v.dataAtlas && v.dataAtlas.scTotalCost && v.dataAtlas.atlasTotalCost && v.isAffiliateTrip && !v.matches.totalCost">
                    <span class="badge danger-badge p-2 ml-2">
                      <a href="#affiliateCharge" class="link-text">NO Match for Affiliate Cost</a>
                    </span>
                  </p>
                </div>
              </div>


            </div>
          </div>

        </div>
        <!--/Second column-->
      </div>

      <!-- second row -->
      <div class="row mt-lg-2">

        <!-- first column -->
        <div class="col-xl-4 col-lg-6 mb-5 ">


          <div class="row">
            <div class="col-md-12 mb-5">
              <!-- general -->
              <div class="card card-cascade narrower">
                <mdb-card>
                  <mdb-body>
                    <div class="row">

                      <!-- left side -->
                      <div class="col-xl-6 col-lg-12 mr-0">
                        <div class="view view-cascade gradient-card-header blue-gradient py-2">
                          <h2 class="h2-responsive mb-0">General</h2>
                        </div>

                        <div class="card-body card-body-cascade">

                          <!-- locations -->
                          <div class="row pt-1 pb-2">
                            <div class="col-xl-12 pt-2" *ngFor='let l of v.data.locations.location'>
                              <p class="lead mb-1 mt-3"><span class="view view-cascade badge info-color p-2">
                                  {{l['@locationPhaseType'] == '0' ? 'Pickup' : l['@locationPhaseType'] == '1' ? 'Drop' : l['@locationPhaseType'] == '2' ? 'Stop' : 'Unknown ' + l['@locationPhaseType']}}
                                  - {{l['@placeType']}}
                                </span></p>

                              <div *ngIf="l['@placeType'] == 'Airport'">
                                <span>{{l.airport['@code']}} {{l.airport['@airline']}} {{l.airport['@number']}},
                                  {{l.airport['@scheduleDate']}}
                                  {{l.airport['@scheduleTime']}}</span>
                              </div>
                              <div *ngIf="l['@placeType'] == 'Address'">
                                <span>{{l.address['@addressLine1']}}, {{l.address['@city']}}, {{l.address['@state']}}
                                  {{l.address['@postalCode']}}</span>
                              </div>
                              <span class="mr-1">(</span>
                              <span>{{l['@dispatchZoneCode']}}</span><span> / </span>
                              <span class="badge p-2"
                                [ngClass]="{'success-badge': l['@pricingZoneCode'] !== 'P9999', 'danger-badge': l['@pricingZoneCode'] === 'P9999' }">{{l['@pricingZoneCode']}}</span>
                              <span class="ml-1">)</span>
                            </div>
                          </div>

                        </div>
                      </div>

                      <!-- right side -->
                      <div class="col-xl-6 col-lg-12 my-3">
                        <div class="px-3">
                          <div class="table-responsive">
                            <table class="table large-header" mdbTable small="true" hover="true">
                              <tbody>
                                <tr>
                                  <td>Price Book</td>
                                  <td>{{v.data.pricing['@priceBook']}}</td>
                                </tr>
                                <tr>
                                  <td>Pricing Rule</td>
                                  <td>{{v.data.pricing['@pricingRuleCode']}}</td>
                                </tr>
                                <tr>
                                  <td>Service Area</td>
                                  <td>{{v.data.pricing['@pricingServiceAreaCode']}}</td>
                                </tr>
                                <tr>
                                  <td>Vehicle Type</td>
                                  <td>{{v.data['@vehicleTypeCode']}}
                                    <span *ngIf="v.dataAtlas" class="badge p-2 ml-2 primary-badge">
                                      {{v.dataAtlas.carType}}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Customer</td>
                                  <td>{{v.data['@customerCode']}}</td>
                                </tr>
                                <tr>
                                  <td>Portal CF#</td>
                                  <td *ngIf="v.data.affPortal">{{v.data.affPortal['@portalResNumber']}}</td>
                                </tr>
                                <tr>
                                  <td>Aff CF#</td>
                                  <td *ngIf="v.data.affPortal">{{v.data.affPortal['@affResNumber']}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div class="text-center">
                            <button mdbBtn type="button" color="primary" outline="true" mdbWavesEffect
                              (click)="priceAtlas(v.confirmNumber, undefined)">Price Atlas</button>
                            <button mdbBtn type="button" color="primary" outline="true" mdbWavesEffect
                              (click)="priceAtlas(v.confirmNumber, 'HOR')">Price Atlas Hourly</button>

                          </div>
                        </div>
                      </div>

                    </div>
                  </mdb-body>
                </mdb-card>
              </div>
            </div>

            <!-- taxes and other -->
            <div class="col-md-12 mb-5">
              <div class="card card-cascade narrower">
                <div class="row">

                  <!-- left side -->
                  <div class="col-xl-6 col-lg-12 mr-0">
                    <div class="view view-cascade gradient-card-header blue-gradient py-2">
                      <h2 class="h2-responsive mb-0">Taxes / Other</h2>
                    </div>
                    <!-- <div class="card-body card-body-cascade pb-0">
                        <div class="row card-body pt-3">
      
                        </div>
                      </div> -->
                  </div>

                  <!-- right side -->
                  <div class="col-xl-6 col-lg-12 mt-3 mb-0">
                    <div class="px-3">
                      <p class="h3-responsive text-center">${{v.data.pricing.taxesAndOther['@total'] | number:'1.2-2'}}
                      </p>
                    </div>
                  </div>

                </div>

                <!-- taxes and other parts -->
                <div class="row card-body">
                  <!-- Taxes -->
                  <div class="col-xl-6 col-xs-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Taxes</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Sales Tax</td>
                              <td>${{v.data.pricing.taxesAndOther.taxes['@salesTax'] | number:'1.2-2'}}
                                ({{v.data.pricing.taxesAndOther.taxes['@salesTaxRate']}})</td>
                            </tr>
                            <tr>
                              <td>Sales Tax Base</td>
                              <td>${{v.data.pricing.taxesAndOther.taxes['@salesTaxBase'] | number:'1.2-2'}}</td>
                            </tr>

                            <tr>
                              <td>WC Tax</td>
                              <td>
                                <span>${{v.data.pricing.taxesAndOther.taxes['@wcTax'] | number:'1.2-2'}}
                                  ({{v.data.pricing.taxesAndOther.taxes['@wcTaxRate']}})</span>
                                <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                  [ngClass]="{'success-badge': v.matches.wcTax, 'danger-badge': !v.matches.wcTax }">
                                  ${{v.dataAtlas.wcTax | number:'1.2-2'}}
                                  ({{v.dataAtlas.wcTaxPercent | number:'1.2-2'}})</span>
                              </td>
                            </tr>

                            <tr>
                              <td>WC Tax Base</td>
                              <td>${{v.data.pricing.taxesAndOther.taxes['@wcTaxBase'] | number:'1.2-2'}}</td>
                            </tr>

                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.dataExtra.scTaxesTotal | number:'1.2-2'}}</strong>
                                <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                  [ngClass]="{'success-badge': v.matches.taxes, 'danger-badge': !v.matches.taxes }">
                                  ${{v.dataExtra.atlasTaxesTotal | number:'1.2-2'}}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- Service Charges -->
                  <div class="col-xl-6  col-xs-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Service Charge</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Charge</td>
                              <td>${{v.data.pricing.taxesAndOther.serviceCharges['@charge'] | number:'1.2-2'}}

                                <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                  [ngClass]="{'success-badge': v.matches.stf, 'danger-badge': !v.matches.stf }">
                                  ${{v.dataAtlas.stf}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Additional</td>
                              <td>{{v.data.pricing.taxesAndOther.serviceCharges['@additional'] | number:'1.2-2'}}</td>
                            </tr>
                            <tr>
                              <td>Total</td>
                              <td>
                                <strong>${{v.data.pricing.taxesAndOther.serviceCharges['@total'] | number:'1.2-2'}}</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- Other -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Other</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.taxesAndOther.other['@total'] | number:'1.2-2'}}

                                </strong></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- custom -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Custom</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.taxesAndOther.custom['@total'] | number:'1.2-2'}}</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>

        <div class="col-xl-8 col-lg-6 mb-5">
          <div class="row">
            <!-- charges -->
            <div class="col-xl-6 col-lg-6 mb-5">
              <div class="card card-cascade narrower">
                <div class="row">

                  <!-- left side -->
                  <div class="col-xl-6 col-lg-12 mr-0">
                    <div class="view view-cascade gradient-card-header blue-gradient py-2">
                      <h2 class="h2-responsive mb-0">Charges</h2>
                    </div>
                    <!-- <div class="card-body card-body-cascade pb-0">
                    <div class="row card-body pt-3">
  
                    </div>
                  </div> -->
                  </div>

                  <!-- right side -->
                  <div class="col-xl-6 col-lg-12 mt-3 mb-0">
                    <div class="px-3">
                      <p class="h3-responsive text-center">
                        ${{v.data.pricing.charges['@total'] | number:'1.2-2'}}
                        <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                          [ngClass]="{'success-badge': v.matches.baseRate, 'danger-badge': !v.matches.baseRate }">
                          ${{v.dataExtra.atlasBaseTotal | number:'1.2-2'}}
                        </span>
                      </p>
                    </div>
                  </div>

                </div>

                <!-- charges parts -->
                <div class="row card-body">
                  <!-- base -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Base</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Tranfer Rate</td>
                              <td>${{v.data.pricing.charges.base['@transferRate'] | number:'1.2-2'}}</td>
                            </tr>
                            <tr>
                              <td>Hourly Charge </td>
                              <td>${{v.data.pricing.charges.base['@hourlyCharge'] | number:'1.2-2'}}</td>
                            </tr>
                            <tr>
                              <td>Billed Min. / Dist.</td>
                              <td>{{v.data.pricing.charges.base['@billedNumberOfMinutes']}} /
                                {{v.data.pricing.charges.base['@billedDistance']}}
                                <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                  [ngClass]="{'success-badge': v.matches.billableMinutes, 'danger-badge': !v.matches.billableMinutes }">
                                  {{v.dataExtra.atlasBillableMinutes | number:'1.2-2'}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Additional</td>
                              <td>${{v.data.pricing.charges.base['@additional'] | number:'1.2-2'}}</td>
                            </tr>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.charges.base['@total'] | number:'1.2-2'}}</strong></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- wait time -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Wait Time</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Hourly Rate</td>
                              <td>${{v.data.pricing.charges.waitTime['@hourlyRate'] | number:'1.2-2'}}</td>
                            </tr>
                            <tr>
                              <td>Pickup Charge</td>
                              <td>${{v.data.pricing.charges.waitTime['@pickupCharges'] | number:'1.2-2'}}
                                ({{v.data.pricing.charges.waitTime['@pickupMinutes']}})
                              </td>
                            </tr>
                            <tr>
                              <td>Dropoff Charge</td>
                              <td>${{v.data.pricing.charges.waitTime['@dropoffCharges'] | number:'1.2-2'}}
                                ({{v.data.pricing.charges.waitTime['@dropoffMinutes']}})</td>
                            </tr>
                            <tr>
                              <td>Additional</td>
                              <td>${{v.data.pricing.charges.base['@additional'] | number:'1.2-2'}}</td>
                            </tr>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.charges.waitTime['@total'] | number:'1.2-2'}}</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- surcharges -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Surcharges</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Off Hour</td>
                              <td>${{v.data.pricing.charges.surcharge['@offHour'] | number:'1.2-2'}}
                                <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                  [ngClass]="{'success-badge': v.matches.lateNight, 'danger-badge': !v.matches.lateNight }">
                                  ${{v.dataAtlas.lateNight | number:'1.2-2'}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Holiday</td>
                              <td>${{v.data.pricing.charges.surcharge['@holiday'] | number:'1.2-2'}}
                                <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                  [ngClass]="{'success-badge': v.matches.holiday, 'danger-badge': !v.matches.holiday }">
                                  ${{v.dataAtlas.holiday | number:'1.2-2'}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Additional</td>
                              <td>${{v.data.pricing.charges.surcharge['@additional'] | number:'1.2-2'}}</td>
                            </tr>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.charges.surcharge['@total'] | number:'1.2-2'}}</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- discount -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Discount</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Type</td>
                              <td>{{v.data.pricing.charges.discount['@type']}}
                                ({{v.data.pricing.charges.discount['@typeValue']}})</td>
                            </tr>
                            <tr>
                              <td>Amount</td>
                              <td>${{v.data.pricing.charges.discount['@amount'] | number:'1.2-2'}}</td>
                            </tr>
                            <tr>
                              <td>Base</td>
                              <td>${{v.data.pricing.charges.discount['@base'] | number:'1.2-2'}}</td>
                            </tr>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.charges.discount['@total'] | number:'1.2-2'}}</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- stops -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Stops</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.charges.stops['@total'] | number:'1.2-2'}}</strong>
                                <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                  [ngClass]="{'success-badge': v.matches.extraStop, 'danger-badge': !v.matches.extraStop }">
                                  ${{v.dataAtlas.extraStop | number:'1.2-2'}}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- custom -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Custom</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.charges.custom['@total'] | number:'1.2-2'}}</strong></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!-- expenses -->
            <div class="col-xl-6 col-lg-6 mb-5">
              <div class="card card-cascade narrower">
                <div class="row">

                  <!-- left side -->
                  <div class="col-xl-6 col-lg-12 mr-0">
                    <div class="view view-cascade gradient-card-header blue-gradient py-2">
                      <h2 class="h2-responsive mb-0">Expenses</h2>
                    </div>
                    <!-- <div class="card-body card-body-cascade pb-0">
                      <div class="row card-body pt-3">
    
                      </div>
                    </div> -->
                  </div>

                  <!-- right side -->
                  <div class="col-xl-6 col-lg-12 mt-3 mb-0">
                    <div class="px-3">
                      <p class="h3-responsive text-center">${{v.data.pricing.expenses['@total'] | number:'1.2-2'}}</p>
                    </div>
                  </div>

                </div>

                <!-- expenses parts -->
                <div class="row card-body">
                  <!-- gratuity -->
                  <div class="col-xl-6 col-xs-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Gratuity</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>

                            <!-- Pricing Rule {{v.data.pricing.expenses.gratuity['@pricingRule']}}<br />
                              Service Area {{v.data.pricing.expenses.gratuity['@serviceArea']}}<br /> -->

                            <tr>
                              <td>Type</td>
                              <td>{{v.data.pricing.expenses.gratuity['@typeValue']}}
                                ({{v.data.pricing.expenses.gratuity['@type']}})</td>
                            </tr>

                            <tr>
                              <td>Amount</td>
                              <td>
                                <span>${{v.data.pricing.expenses.gratuity['@charge'] | number:'1.2-2'}}</span>
                                <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                  [ngClass]="{'success-badge': v.matches.grat, 'danger-badge': !v.matches.grat }">
                                  ${{v.dataAtlas.grat | number:'1.2-2'}} ({{v.dataAtlas.gratPercent}})
                                </span>
                              </td>
                            </tr>

                            <tr>
                              <td>Base</td>
                              <td>${{v.data.pricing.expenses.gratuity['@base'] | number:'1.2-2'}}</td>
                            </tr>

                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.expenses.gratuity['@total'] | number:'1.2-2'}}</strong></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- surcharge -->
                  <div class="col-xl-6  col-xs-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Surcharges</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>STC</td>
                              <td>${{v.data.pricing.expenses.surcharges['@stc'] | number:'1.2-2'}}</td>
                            </tr>
                            <tr>
                              <td>Fuel</td>
                              <td>${{v.data.pricing.expenses.surcharges['@fuel'] | number:'1.2-2'}}
                                <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                  [ngClass]="{'success-badge': v.matches.fsc, 'danger-badge': !v.matches.fsc }">
                                  ${{v.dataAtlas.fsc | number:'1.2-2'}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.expenses.surcharges['@total'] | number:'1.2-2'}}</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- misc -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Misc</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Charge 1</td>
                              <td>${{v.data.pricing.expenses.misc['@charge1'] | number:'1.2-2'}}
                                <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                  [ngClass]="{'success-badge': v.matches.miscCode1, 'danger-badge': !v.matches.miscCode1 }">
                                  ${{v.dataAtlas.miscCode1 | number:'1.2-2'}}</span>

                              </td>
                            </tr>
                            <tr>
                              <td>Charge 2</td>
                              <td>${{v.data.pricing.expenses.misc['@charge2'] | number:'1.2-2'}}
                                <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                  [ngClass]="{'success-badge': v.matches.miscCode2, 'danger-badge': !v.matches.miscCode2 }">
                                  ${{v.dataAtlas.miscCode2 | number:'1.2-2'}}</span>

                              </td>
                            </tr>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.expenses.misc['@total'] | number:'1.2-2'}}</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- parking -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Parking</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.expenses.parking['@total'] | number:'1.2-2'}}
                                  <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                    [ngClass]="{'success-badge': v.matches.parkingFee, 'danger-badge': !v.matches.parkingFee }">
                                    ${{v.dataAtlas.parkingFee | number:'1.2-2'}}
                                  </span></strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- Airport Fee -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Airport Fee</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.expenses.airportFee['@total'] | number:'1.2-2'}}
                                  <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                    [ngClass]="{'success-badge': v.matches.airportFee, 'danger-badge': !v.matches.airportFee }">
                                    ${{v.dataAtlas.airportFee | number:'1.2-2'}}
                                  </span>

                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- Extra Options -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Extra Options</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.expenses.extraOptions['@total'] | number:'1.2-2'}}</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- Tolls -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Tolls</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.expenses.tolls['@total'] | number:'1.2-2'}}
                                  <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                                    [ngClass]="{'success-badge': v.matches.tolls, 'danger-badge': !v.matches.tolls }">
                                    ${{v.dataAtlas.tolls | number:'1.2-2'}}
                                  </span>
                                </strong></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- custom -->
                  <div class="col-xl-6">
                    <div class="mb-2">
                      <p class="mb-1 h2"><span class="view view-cascade badge info-color p-2"
                          style="width:100%; margin-left: 0px;">Custom</span></p>
                      <div class="table-responsive">
                        <table class="table large-header" mdbTable small="true" hover="true">
                          <tbody>
                            <tr>
                              <td>Total</td>
                              <td><strong>${{v.data.pricing.expenses.custom['@total'] | number:'1.2-2'}}</strong></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <!-- affiliate charge -->
            <div id="affiliateCharge" class="col-xl-6 col-lg-6 mb-5"
              *ngIf="v.dataAtlas && v.dataAtlas.scTotalCost && v.dataAtlas.atlasTotalCost && v.isAffiliateTrip">
              <div class="card card-cascade narrower">
                <div class="row">
                  <!-- left side -->
                  <div class="col-xl-6 col-lg-12 mr-0">
                    <div class="view view-cascade gradient-card-header blue-gradient py-2">
                      <h2 class="h2-responsive mb-0">Affiliate Cost</h2>
                    </div>
                  </div>
                  <!-- right side -->
                  <div class="col-xl-6 col-lg-12 mt-3 mb-0">
                    <div class="px-3">
                      <p class="h3-responsive text-center">
                        ${{v.dataAtlas.scTotalCost | number:'1.2-2'}}
                        <span *ngIf="v.dataAtlas" class="badge p-2 ml-2"
                          [ngClass]="{'success-badge': v.matches.totalCost, 'danger-badge': !v.matches.totalCost }">
                          ${{v.dataAtlas.atlasTotalCost | number:'1.2-2'}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end affiliate charge   -->
          </div>
        </div>




      </div>


      <div *ngIf='v.isError'>
        <p>error: {{v.errorMessage}}</p>
      </div>
    </div>

  </div>